<div class="conf-wrapper" [ngClass]="!displayMode ? ' page-content' : ''">
    <div *ngIf="ready">
        <!-- Not Found -->
        <div *ngIf="!confirmationInfo && !resultInfo" class="conf-empty">
            <i class="fa fa-exclamation-circle conf-empty__icon"></i>
            <p class="conf-empty__text">No Confirmation Found</p>
        </div>

        <!-- Generic Result -->
        <div *ngIf="!!resultInfo" class="conf-result-card">
            <div class="conf-result-card__body">{{ resultInfo }}</div>
        </div>

        <div *ngIf="confirmationInfo && !resultInfo">
            <!-- ── Header Banner ── -->
            <div class="conf-header">
                <div class="conf-header__left">
                    <div class="conf-header__dealer">
                        {{ confirmationInfo.Dealer }}
                        <span *ngIf="confirmationInfo.SalesRepConfirmation" class="conf-badge conf-badge--warning ms-2">Sales Rep Only</span>
                    </div>
                    <div class="conf-header__meta">
                        <span class="conf-header__meta-label">Order Code</span>
                        <span class="conf-header__code">{{ confirmationCode }}</span>
                    </div>
                </div>
                <div class="conf-header__right">
                    <span class="conf-badge" [ngClass]="complete ? 'conf-badge--success' : 'conf-badge--pending'">
                        <i class="fa" [ngClass]="complete ? 'fa-check-circle' : 'fa-clock-o'"></i>
                        Confirmation {{ complete ? 'Complete' : 'Required' }}
                    </span>
                </div>
            </div>

            <!-- ── Message Block ── -->
            <div class="conf-message-block" *ngIf="confirmationInfo.Message">
                <p class="conf-message-block__main">{{ confirmationInfo.Message }}</p>
                <p *ngIf="confirmationInfo.Message2" class="conf-message-block__sub">{{ confirmationInfo.Message2 }}</p>
            </div>

            <!-- ── Order Summary Cards ── -->
            <div class="conf-section" *ngIf="orderInfo && orderInfo.InvoiceNumber !== 0">
                <div class="conf-summary-grid">
                    <div class="conf-summary-card">
                        <div class="conf-summary-card__label">Sales Order</div>
                        <div class="conf-summary-card__value">#{{ orderInfo.InvoiceNumber }}</div>
                    </div>
                    <div class="conf-summary-card">
                        <div class="conf-summary-card__label">PO Number</div>
                        <div class="conf-summary-card__value">{{ orderInfo.PONumber || '—' }}</div>
                    </div>
                    <div class="conf-summary-card conf-summary-card--address">
                        <div class="conf-summary-card__label">Ship-To Address</div>
                        <div class="conf-summary-card__value conf-summary-card__value--address">
                            <span>{{ orderInfo.ShipToAddress1 }}</span>
                            <span *ngIf="orderInfo.ShipToAddress2">{{ orderInfo.ShipToAddress2 }}</span>
                            <span>{{ orderInfo.ShipToCity }}, {{ orderInfo.ShipToState }} {{ orderInfo.ShipToZip }}</span>
                        </div>
                    </div>
                    <div class="conf-summary-card">
                        <div class="conf-summary-card__label">Delivery</div>
                        <div class="conf-summary-card__value conf-summary-card__value--delivery">
                            {{ orderInfo.DeliveryOptionDescription?.length > 0 ? orderInfo.DeliveryOptionDescription : orderInfo.DeliveryOptionName }}
                        </div>
                    </div>
                    <div class="conf-summary-card conf-summary-card--total">
                        <div class="conf-summary-card__label">Order Total</div>
                        <div class="conf-summary-card__value conf-summary-card__value--money">{{ displayTotal | currency }}</div>
                    </div>
                    <div class="conf-summary-card conf-summary-card--total" *ngIf="!dealerChannelPartner">
                        <div class="conf-summary-card__label">{{ achPortalEnabled && orderInfo.IsWinterOrder ? '10% Down Payment' : 'Pre-Payment Total' }}</div>
                        <div class="conf-summary-card__value conf-summary-card__value--money">{{ displayAchTotal | currency }}</div>
                    </div>
                </div>
            </div>

            <!-- ── Response Form ── -->
            <div class="conf-section conf-form-section" *ngIf="!complete">
                <div class="conf-section__title">Your Response</div>
                <div class="conf-form-row">
                    <dx-form [formData]="dealerResponse" [width]="'420px'" validationGroup="mainValidationGroup">
                        <dxi-item *ngIf="!hidePaymentMethod" [label]="{ text: 'Payment Method' }">
                            <div *dxTemplate>
                                <dx-select-box
                                    [(value)]="dealerResponse.selectedPaymentMethodId"
                                    [items]="paymentMethods"
                                    valueExpr="Id"
                                    displayExpr="Name"
                                    (onValueChanged)="onPaymentMethodChanged($event)"
                                >
                                </dx-select-box>
                            </div>
                            <dxi-validation-rule *ngIf="!hidePaymentMethod" type="required" message="Required"></dxi-validation-rule>
                            <dxi-validation-rule
                                *ngIf="!hidePaymentMethod"
                                type="custom"
                                message="Required"
                                [validationCallback]="validatePaymentMethod"
                                [reevaluate]="true"
                            ></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item
                            *ngIf="selectedPaymentMethod && selectedPaymentMethod.RequiresNorthpoint && selectedPaymentMethodId != redOakMethodId"
                            dataField="northpointOrRedOakNumber"
                            [label]="{ text: 'Northpoint CIN #' }"
                            [editorOptions]="{ disabled: confirmationInfo.NorthpointNumberValidated }"
                        >
                            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item
                            *ngIf="selectedPaymentMethod && selectedPaymentMethod.RequiresNorthpoint && selectedPaymentMethodId == redOakMethodId"
                            dataField="northpointOrRedOakNumber"
                            [label]="{ text: 'Red Oak CIN #' }"
                            [editorOptions]="{ disabled: confirmationInfo.RedOakNumberValidated }"
                        >
                            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item *ngIf="selectedPaymentMethod && selectedPaymentMethod.RequiresAch" dataField="achEmail" [label]="{ text: 'Email for ACH Auth. Form' }">
                            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                            <dxi-validation-rule type="custom" message="Invalid email" [validationCallback]="validateEmail" [reevaluate]="true"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="confirmedBy" [label]="{ text: declineMessage }">
                            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item *ngIf="dealerDeliveryConfirmationEnabled" [label]="{ text: 'Delivery' }">
                            <div *dxTemplate>
                                <dx-select-box
                                    [(value)]="dealerResponse.selectedDeliveryId"
                                    [items]="deliveryOptions"
                                    valueExpr="id"
                                    displayExpr="displayExpr"
                                    (onValueChanged)="onDeliveryChanged($event)"
                                >
                                </dx-select-box>
                            </div>
                            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
                        </dxi-item>
                    </dx-form>
                    <div *ngIf="!!selectedPaymentMethod && selectedPaymentMethod.PaymentTerms" class="conf-info-note">
                        <div class="conf-info-note__label"><i class="fa fa-info-circle me-1"></i>Payment Terms</div>
                        <div class="conf-info-note__body">{{ selectedPaymentMethod.PaymentTerms }}</div>
                    </div>
                    <div *ngIf="!!selectedDelivery && selectedDelivery.info" class="conf-info-note">
                        <div class="conf-info-note__label"><i class="fa fa-info-circle me-1"></i>Delivery</div>
                        <div class="conf-info-note__body">{{ selectedDelivery.info }}</div>
                    </div>
                </div>

                <div *ngIf="!showDecline && deliveryAcknowledgmentMessage" class="conf-info-note conf-info-note--warning">
                    <div class="conf-info-note__label"><i class="fa fa-truck me-1"></i>Delivery Acknowledgment</div>
                    <div class="conf-info-note__body mb-2">{{ deliveryAcknowledgmentMessage }}</div>
                    <dx-check-box *ngIf="requiresDeliveryAcknowledgment" [(value)]="deliveryAcknowledged" text="I Acknowledge"></dx-check-box>
                </div>

                <!-- Action Buttons -->
                <div class="conf-actions">
                    <button
                        *ngIf="!showDecline"
                        class="conf-btn conf-btn--approve"
                        (click)="respond('Approve')"
                        [disabled]="displayMode || processing || requiresFreightChangeRequest || (requiresDeliveryAcknowledgment && !deliveryAcknowledged)"
                    >
                        <i class="fa fa-check me-2"></i>Approve / Confirm
                    </button>
                    <button class="conf-btn conf-btn--decline" (click)="toggleDecline()" [disabled]="displayMode || processing">
                        <i class="fa fa-times me-2"></i>Submit Changes
                    </button>
                </div>
            </div>

            <!-- ── Decline Panel ── -->
            <div #declineBox *ngIf="showDecline" [hidden]="complete" [disabled]="displayMode" class="conf-decline-panel">
                <div class="conf-decline-panel__title"><i class="fa fa-exclamation-triangle me-2"></i>Submit Changes to This Order</div>
                <div class="conf-decline-panel__body">
                    <div class="conf-decline-row">
                        <label class="conf-decline-label">Reason</label>
                        <dx-select-box [(value)]="selectedCancelReason" [items]="cancelReasonOptions" [disabled]="freightChangeRequestAutoOpened" class="flex-fill">
                            <dx-validator validationGroup="mainValidationGroup">
                                <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                    <div
                        *ngIf="selectedCancelReason === 'I wish to make changes to my order' || freightChangeRequestAutoOpened"
                        class="conf-decline-row conf-decline-row--notes"
                    >
                        <label class="conf-decline-label">Notes</label>
                        <dx-text-area [(value)]="cancelNotes" height="85" class="flex-fill"></dx-text-area>
                    </div>
                    <div class="conf-decline-row conf-decline-row--check">
                        <dx-check-box [(value)]="requestContact" [text]="'Please have my Sales Rep contact me'"></dx-check-box>
                    </div>
                    <div class="conf-decline-actions">
                        <button class="conf-btn conf-btn--decline" (click)="respond()"><i class="fa fa-paper-plane me-2"></i>Submit</button>
                        <button class="conf-btn conf-btn--ghost" (click)="toggleDecline()">Cancel</button>
                    </div>
                </div>
            </div>

            <!-- ── Line Items ── -->
            <div class="conf-section" *ngIf="!!orderLineInfos && orderLineInfos.length > 0">
                <div class="conf-section__title">Order Line Items</div>
                <div class="conf-table-wrapper">
                    <table class="conf-table">
                        <thead>
                            <tr>
                                <th>Line</th>
                                <th>Qty</th>
                                <th>Part #</th>
                                <th>Description</th>
                                <th>Notes</th>
                                <th class="conf-table__money">Tier Price</th>
                                <th class="conf-table__money" *ngIf="(!achPortalEnabled || !orderInfo.IsWinterOrder) && !dealerChannelPartner">ACH Price</th>
                                <th class="conf-table__money" *ngIf="(!achPortalEnabled || !orderInfo.IsWinterOrder) && !dealerChannelPartner">Tax</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orderLine of visibleOrderLineInfos" [ngClass]="orderLine.IsOption ? 'conf-table__row--option' : ''">
                                <td>{{ orderLine.LineNumber }}</td>
                                <td>{{ orderLine.Quantity }}</td>
                                <td [ngClass]="orderLine.IsOption ? 'conf-table__part--option' : 'conf-table__part--main'">{{ orderLine.PartNumber }}</td>
                                <td>{{ orderLine.Description }}</td>
                                <td>{{ orderLine.Note }}</td>
                                <td class="conf-table__money">{{ orderLine.Price | currency }}</td>
                                <td class="conf-table__money" *ngIf="(!achPortalEnabled || !orderInfo.IsWinterOrder) && !dealerChannelPartner">
                                    {{ orderLine.AchPrice | currency }}
                                </td>
                                <td class="conf-table__money" *ngIf="(!achPortalEnabled || !orderInfo.IsWinterOrder) && !dealerChannelPartner">{{ orderLine.Tax | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- ── Completion Summary ── -->
            <div *ngIf="confirmationInfo && complete" class="conf-complete-card">
                <div class="conf-complete-card__icon-wrap">
                    <i class="fa fa-check-circle conf-complete-card__icon"></i>
                </div>
                <div class="conf-complete-card__content">
                    <div class="conf-complete-card__thanks">Thank you for your confirmation.</div>
                    <div class="conf-complete-grid">
                        <div class="conf-complete-item">
                            <span class="conf-complete-item__label">Payment Method</span>
                            <span class="conf-complete-item__value">{{ confirmationInfo.ConfirmationPaymentMethodName }}</span>
                        </div>
                        <div class="conf-complete-item" *ngIf="dealerDeliveryConfirmationEnabled && orderInfo?.DealerDeliveryOptionName">
                            <span class="conf-complete-item__label">Delivery</span>
                            <span class="conf-complete-item__value">{{
                                orderInfo.DealerDeliveryOptionDescription?.length > 0 ? orderInfo.DealerDeliveryOptionDescription : orderInfo.DealerDeliveryOptionName
                            }}</span>
                        </div>
                        <div class="conf-complete-item">
                            <span class="conf-complete-item__label">{{ confirmationInfo.Declined ? 'Submitted By' : 'Confirmed By' }}</span>
                            <span class="conf-complete-item__value">{{ confirmationInfo.ConfirmedBy }}</span>
                        </div>
                        <div class="conf-complete-item">
                            <span class="conf-complete-item__label">Order Status</span>
                            <span
                                class="conf-badge conf-badge--lg"
                                [ngClass]="confirmationInfo.Approved ? 'conf-badge--success' : confirmationInfo.Declined ? 'conf-badge--danger' : 'conf-badge--pending'"
                            >
                                {{ confirmationInfo.Approved ? 'Approved' : confirmationInfo.Declined ? 'Changes Submitted' : 'Pending' }}
                            </span>
                        </div>
                        <div class="conf-complete-item" *ngIf="confirmationInfo.CancelReason">
                            <span class="conf-complete-item__label">Reason for Changes</span>
                            <span class="conf-complete-item__value">{{ confirmationInfo.CancelReason }}</span>
                        </div>
                        <div class="conf-complete-item" *ngIf="confirmationInfo.RequestedSalesRepContact">
                            <span class="conf-complete-item__value"><i class="fa fa-phone me-1"></i>Requested sales rep to contact me</span>
                        </div>
                        <div class="conf-complete-item" *ngIf="confirmationInfo.Notes">
                            <span class="conf-complete-item__label">Notes</span>
                            <span class="conf-complete-item__value">{{ confirmationInfo.Notes }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── ACH Section ── -->
            <div *ngIf="achPortalEnabled && confirmationInfo && confirmationInfo.Approved && confirmationInfo.PaymentRequiredAch" class="conf-section conf-ach-section">
                <div class="conf-section__title">ACH Authorization</div>
                <div *ngIf="confirmationInfo.Approved" class="conf-ach-status">
                    <div class="conf-ach-status__row">
                        <span class="conf-complete-item__label me-2">ACH Status</span>
                        <span class="conf-badge conf-badge--lg" [ngClass]="confirmationInfo.AchStatus === 'Approved' ? 'conf-badge--success' : 'conf-badge--danger'">
                            {{ confirmationInfo.AchStatus }}
                        </span>
                        <a
                            *ngIf="confirmationInfo.IsAchEmailSent && confirmationInfo.AchStatus !== 'Approved'"
                            title="Refresh Data"
                            (click)="refresh()"
                            class="conf-icon-link ms-3"
                        >
                            <i class="fa fa-refresh"></i>
                        </a>
                    </div>
                    <div *ngIf="confirmationInfo.AchStatus === 'Declined'" class="conf-ach-status__row mt-2">
                        <span class="conf-complete-item__label me-2">Decline Reason</span>
                        <span class="text-danger">{{ confirmationInfo.AchDeclineReason }}</span>
                    </div>
                </div>
                <dx-form [formData]="dealerResponse" validationGroup="emailValidationGroup">
                    <dxi-item *ngIf="confirmationInfo.Approved" [label]="{ text: 'Email for ACH Auth. Form' }">
                        <div *dxTemplate class="d-flex align-items-center">
                            <dx-text-box [(value)]="dealerResponse.achEmail" [readOnly]="confirmationInfo.IsAchEmailSent" [width]="'300px'">
                                <dx-validator validationGroup="emailValidationGroup">
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                            <button
                                *ngIf="!confirmationInfo.IsAchEmailSent && !confirmationInfo.SalesRepConfirmation"
                                class="conf-btn conf-btn--approve ms-3"
                                (click)="resendEmail()"
                                [disabled]="displayMode || confirmationInfo.IsAchEmailSent"
                            >
                                <i class="fa fa-envelope me-2"></i>Email ACH Authorization Form
                            </button>
                            <a
                                *ngIf="confirmationInfo.IsAchEmailSent && confirmationInfo.AchStatus === 'Declined'"
                                title="Resend Email"
                                (click)="resendEmail(true)"
                                class="conf-icon-link ms-3"
                            >
                                <i class="fa fa-share" aria-hidden="true"></i>
                            </a>
                            <a
                                *ngIf="confirmationInfo.IsAchEmailSent && confirmationInfo.AchStatus !== 'Approved'"
                                title="Remove ACH Link"
                                (click)="removeAch($event, attachment)"
                                class="conf-icon-link conf-icon-link--danger ms-3"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </a>
                        </div>
                        <dxi-validation-rule *ngIf="!confirmationInfo.IsAchEmailSent" type="required"></dxi-validation-rule>
                    </dxi-item>
                </dx-form>
                <div *ngIf="confirmationInfo.AchStatus !== 'Approved' && confirmationInfo.AchStatus !== 'Declined'" class="conf-ach-notice">
                    <i class="fa fa-info-circle me-2"></i>Your order will be submitted when the ACH Authorization Form is received.
                </div>
            </div>
        </div>
    </div>
</div>
